import { HeroTextProps } from 'components/HOCs/withHeroText'
import { WithPartnerProps } from 'components/HOCs/WithPartnerProps'
import { ReferralProps } from 'components/HOCs/WithReferralDisclosureRequired'
import { RemoteStringsProps } from 'components/HOCs/withRemoteStrings'
import { IErrorModalProps } from 'utils/Apollo/apolloErrorHandlingProvider'
import Environment from 'utils/environment'
import { WithFlowRouterProps } from 'utils/FlowProvider'
import { FunnelContextProps } from 'utils/FunnelContext'
import { WithOptimizelyProps } from 'utils/Optimizely'

export enum InvestmentMode {
  Recurring = 0,
  OneTime = 1,
}

export type HandlerProps = {
  handleCTA: () => void
  handleSkip: (action: 'continue' | 'one-time') => () => void
  handleInvestmentModeChanged: () => void
  handleLinkAccount: () => void
  handleRecurringAmountChange: () => void
  handleOneTimeAmountChange: () => void
  handleModalClosed: () => void
  handleModalConfirmed: () => void
}

export type Added = {
  history: any
  env: Environment
  optimizely: any
} & ReferralProps

export type GqlInitialStateProps = {
  fundingSourceInfo: any // Use Generated type here
  laterAccounts: any
}

export type GqlProps = {
  makeInvestment: (context: any) => Promise<any>
  updateRecurringInvestment: (context: any) => Promise<any>
  createLaterContribution: (context: any) => Promise<any>
  fundingSource: any
  laterAccountId: string
}

export type StateProps = {
  investmentMode: InvestmentMode
  recurringAmount: string
  oneTimeAmount: string
  confirmModalOpen: boolean
  noFundingSourceModalOpen: boolean
  loading: boolean
  submitting: boolean
  text: string
  header: string
  setInvestmentMode: (investmentMode: InvestmentMode) => void
  setRecurringAmount: (recurringAmount: string) => void
  setOneTimeAmount: (oneTimeAmount: string) => void
  setConfirmModalOpen: (confirmModalOpen: boolean) => void
  setNoFundingSourceModalOpen: (noFundingSourceModalOpen: boolean) => void
  setSubmitting: (submitting: boolean) => void
}

export type InnerProps = HandlerProps &
  StateProps &
  GqlProps &
  Added &
  WithFlowRouterProps &
  HeroTextProps &
  WithPartnerProps &
  RemoteStringsProps &
  WithOptimizelyProps &
  IErrorModalProps &
  FunnelContextProps
